import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Token } from 'src/app/app.model';
import { AppService } from 'src/app/app.service';
import { CacheService } from 'src/app/cache.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HubspotService {
  
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  private appUrl = environment.apiUrl;
  constructor(private http: HttpClient, private appService: AppService,
    private cacheService: CacheService) {
    
  }

  
  private setAuthHeader() {
    return this.headers.set(
      'Authorization', 
      `Bearer ${this.cacheService.getObject<Token>('saras_auth_key').token}`
    );
  }
  

  createNewContact(body) {
    // const headers;
    // return this.http
    // .post<any>(`${this.contactApiUrl}`, body, {
    //   headers: headers
    // }).toPromise()
    // .catch((error) => {
    //   console.log(error);
    // })
  }

  async createSignupEvent(userData) {
    await this.appService.getRefreshToken();
    const headers = this.setAuthHeader();

    return this.http
      .post<any>(`${this.appUrl}user/hubspot/signup`, userData, {
        headers
      })
      .toPromise()
      .catch((error) => console.log(error))
  }

  async activateAccountEvent(userData) {
    await this.appService.getRefreshToken();
    const headers = this.setAuthHeader();

    return this.http
      .post<any>(`${this.appUrl}user/hubspot/account-activate`, userData, {
        headers
      })
      .toPromise()
      .catch((error) => console.log(error))
  }
}
